/** @typedef {import('../../../shared/OfferService/OffersProps').default} Props */

import { translate } from '../../../Internationalization';
import AdminVendors from './AdminVendors';
import flags from '../../../../shared/Flags';
import FormSuccessMessages from '../../../../shared/Forms/Messages/FormSuccessMessages';
import images from '../../../../config/local/images';
import LinkButton from '../../../../shared/LinkButton';
import paths from '../../../../config/local/paths';
import React from 'react';
import useGetAdminVendors from '../../../../Hooks/Admin/Getters/useGetAdminVendors/useGetAdminVendors';
import useIsGated from '../../../../Hooks/Shared/useIsGated/useIsGated';

const view = 'domain';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
export default function ViewOffers(props) {
	// vendors are unlocked for admins as long as at least one group has the subscription
	const gated = useIsGated(flags.vendor.add, { role: 'admin' });
	const { total } = useGetAdminVendors(view, 1, gated.isGated);

	return (
		<React.Fragment>
			<header className="mt-10 mb-6 md:flex justify-between items-center">
				<h1 className="hl-ms-6 mb-6 md:mb-0">
					{`${translate('admin.pages.offers.view.title')}`}{' '}
					{total ? `(${total})` : ''}
				</h1>

				<section className="button-group">
					<LinkButton
						icon={images.icons.eye}
						to={paths.app.admin.offers.groups}
					>
						{translate('admin.pages.offers.view.view_groups')}
					</LinkButton>

					{!gated.isGated ? (
						<LinkButton
							icon={images.icons.plus}
							to={paths.app.admin.offers.add}
						>
							{translate('global.offers.add_title')}
						</LinkButton>
					) : null}
				</section>
			</header>

			{props.location?.state?.message ? (
				<FormSuccessMessages messages={props.location.state.message} />
			) : null}

			<AdminVendors view={view} />
		</React.Fragment>
	);
}
